export const ContractConditionActions = {
  SELECTED: 'SELECTED',
  CLOSE: 'CLOSE'
}
